import {Error, ValidationResult, Validator} from '@/type/validation/result';

import {半角カナ禁止, 必須入力, 日付書式} from '@/type/validation/validator';
import {移動履歴検索依頼型} from '@/type/movement/records/history/部署間移動履歴';

export default class 部署間移動履歴検索条件入力チェッカー {
  単項目チェック結果: Error[];
  相関チェック結果: Error[];

  constructor(target: 移動履歴検索依頼型) {
    const 単項目チェック = new ValidationResult(単項目チェックvalidators);
    単項目チェック.validate(target);
    this.単項目チェック結果 = 単項目チェック.getErrors;
    const 移動日範囲エラー = 移動日範囲のFROMがTOより小(target);
    this.相関チェック結果 = 移動日範囲エラー;
  }

  hasErrors(): boolean {
    return this.単項目チェック結果.length > 0 || this.相関チェック結果.length > 0;
  }

  hasError(name: string): boolean {
    return this.単項目チェック結果.some((error) => (error.name === name && error.index === 0));
  }

  errorMessages(): string[] {
    return this.単項目チェック結果.concat(this.相関チェック結果)
      .map((value) => `${value.message}`);
  }
}

const 商品名カナ検索文字列Validator = {
  name: '商品名カナ検索文字列',
  constraints: [
    {method: 半角カナ禁止, message: '商品名カナに半角カナが含まれています'},
  ],
};
const 移動年月日検索開始日Validator = {
  name: '移動年月日検索開始日',
  constraints: [
    {method: 必須入力, message: '移動年月日の開始日は入力必須項目です'},
    {method: 日付書式, message: '移動年月日検索開始日の書式を正しく入力してください'},
  ],
};

const 移動年月日検索終了日Validator = {
  name: '移動年月日検索終了日',
  constraints: [
    {method: 日付書式, message: '移動年月日検索終了日の書式を正しく入力してください'},
  ],
};

const 単項目チェックvalidators: Validator[] = [
  商品名カナ検索文字列Validator,
  移動年月日検索開始日Validator,
  移動年月日検索終了日Validator,
];

function 移動日範囲のFROMがTOより小(target: 移動履歴検索依頼型): Error[] {
  const errors: Error[] = [];
  if (target.移動年月日検索開始日 == null || target.移動年月日検索終了日 == null) return errors;
  if (target.移動年月日検索開始日.valueOf() > target.移動年月日検索終了日.valueOf()) {
    errors.push({index: 0, message: '移動日の範囲指定が間違っています', constraint: '', name: '移動日範囲エラー'});
  }
  return errors;
}
